/* Reuse Wokiee's drawer, outside sticky-header containing blocks. */
(function () {
  'use strict';
  if (window.PiexMobileNav) return;
  window.PiexMobileNav = true;
  var nav;
  var lastY = window.scrollY;
  var distance = 0;
  var direction = 0;
  var frame = 0;
  var mobile = window.matchMedia('(max-width: 1024px)');
  // Sealed v7: only a person's gesture hides the bar. Scroll restoration after "back" is not a gesture.
  var gesture = false;

  function show() { if (nav) nav.dataset.hidden = 'false'; }
  function mount() {
    document.querySelectorAll('[data-piex-mobile-nav]').forEach(function (candidate) {
      if (candidate === nav) return;
      if (nav) nav.remove();
      nav = candidate;
      document.body.appendChild(nav);
      nav.addEventListener('focusin', show);
      var details = nav.querySelector('menu-drawer > details');
      details.addEventListener('toggle', function () {
        var summary = details.querySelector('summary');
        summary.setAttribute('aria-expanded', String(details.open));
        show();
        lastY = window.scrollY;
        if (!details.open && details.contains(document.activeElement)) summary.focus({ preventScroll: true });
      });
    });
    show();
  }
  function update() {
    frame = 0;
    var y = Math.max(0, window.scrollY);
    if (!nav || !mobile.matches) { lastY = y; return; }
    if (document.body.classList.contains('overflow-hidden') || nav.querySelector('details[open]')) {
      lastY = y; distance = 0; show(); return;
    }
    if (!gesture) { lastY = y; distance = 0; show(); return; }
    var delta = y - lastY;
    var nextDirection = Math.sign(delta);
    if (nextDirection !== direction) distance = 0;
    distance += Math.abs(delta);
    direction = nextDirection;
    lastY = y;
    if (y < 80) show();
    else if (distance >= 12) {
      nav.dataset.hidden = String(delta > 0);
      distance = 0;
    }
  }
  ['touchstart', 'wheel', 'keydown', 'pointerdown'].forEach(function (type) {
    window.addEventListener(type, function () { gesture = true; }, { passive: true, capture: true });
  });
  window.addEventListener('pageshow', function () { gesture = false; lastY = window.scrollY; distance = 0; show(); });
  window.addEventListener('scroll', function () {
    if (!frame) frame = requestAnimationFrame(update);
  }, { passive: true });
  mobile.addEventListener('change', function () {
    if (nav && !mobile.matches && nav.querySelector('menu-drawer > details[open]')) {
      nav.querySelector('menu-drawer').closeMenuDrawer('resize');
    }
    show(); lastY = window.scrollY; distance = 0;
  });
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', function (event) {
    if (nav && nav.dataset.sectionId === event.detail.sectionId) {
      if (nav.querySelector('details[open]')) nav.querySelector('menu-drawer').closeMenuDrawer('unload');
      nav.remove(); nav = null;
    }
  });
  mount();
}());
